module.exports = __webpack_public_path__ + "static/media/good-parts.19a8629d.jpg";